module.exports = __webpack_public_path__ + "media/spiral-800.f2511a2e.mp4";